// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__3PTnr","disabled":"FileBtn_disabled__217Fp","warn":"FileBtn_warn__1p4d5","fade":"FileBtn_fade__1yc9U"};